/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Llegó el momento de aprender a generar una serie de componentes a partir de la información que recibimos en un array.`}</p>
    <p>{`Primero vamos a analizar un ejemplo sencillo donde iteraremos una lista de gatos para mostrar el nombre de cada gatito con cada una de las tecnologías.`}</p>
    <p>{`Después analizaremos como renderizar las estadísticas de un Pokémon para conocer sus fortalezas y sus debilidades.`}</p>
    <p><img parentName="p" {...{
        "src": "/images/pokedex/pokedex-stats.png",
        "alt": "Pokédex Statas"
      }}></img></p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;